import React from 'react';
import AdminLayout from '../layouts/AdminLayout';
import BannerManagement from '../components/BannerManagement';

const AdminBanners = () => {
  return (
    <AdminLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Banner Management</h1>
          <p className="text-sm text-gray-600">Create and manage banners for the home page</p>
        </div>
        <BannerManagement />
      </div>
    </AdminLayout>
  );
};

export default AdminBanners; 